import { mediaQueryLarge } from '@theme/use-device-detection'

const INNER_SELECTOR = '[data-sticky-stack-inner]'
const OFFSET_PROPERTY = '--sticky-stack-offset'

class StickyStack extends HTMLElement {
  #inner = null
  #observer = null

  /**
   * @param {MediaQueryListEvent} event
   * @returns {void}
   */
  #onBreakpointChange = (event) => {
    if (event.matches) {
      this.#startMeasuring()
      return
    }
    this.#stopMeasuring()
  }

  #measure = () => {
    if (!this.#inner) return

    if (!mediaQueryLarge.matches) {
      this.#clearOffset()
      return
    }

    const overflow = this.#inner.offsetHeight - window.innerHeight
    this.style.setProperty(
      OFFSET_PROPERTY,
      `${Math.max(0, Math.round(overflow))}px`
    )
  }

  connectedCallback() {
    this.#inner = this.querySelector(INNER_SELECTOR)
    if (!this.#inner) return

    mediaQueryLarge.addEventListener('change', this.#onBreakpointChange)
    if (mediaQueryLarge.matches) this.#startMeasuring()
  }

  disconnectedCallback() {
    mediaQueryLarge.removeEventListener('change', this.#onBreakpointChange)
    this.#stopMeasuring()
  }

  #startMeasuring() {
    if (this.#observer) return

    this.#observer = new ResizeObserver(() => this.#measure())
    this.#observer.observe(this.#inner)
    window.addEventListener('resize', this.#measure)
    this.#measure()
  }

  #stopMeasuring() {
    this.#observer?.disconnect()
    this.#observer = null
    window.removeEventListener('resize', this.#measure)
    this.#clearOffset()
  }

  #clearOffset() {
    this.style.removeProperty(OFFSET_PROPERTY)
  }
}

customElements.define('sticky-stack', StickyStack)
